import { Flex, FullScreenFlex, Text, Button, Link } from "@shared/primitive-components"
import * as styles from "../styles/defaultFallbackComponentStyles"

const refreshPage = () => {
  window.location.reload()
}

export type FallbackComponentProps = React.ComponentPropsWithoutRef<typeof Flex> &
  Readonly<{
    error: Error
    componentStack: string
    debug?: boolean
  }>

export const DefaultFallbackComponent: React.FC<FallbackComponentProps> = ({
  error,
  componentStack,
  debug = process.env.NODE_ENV === `development`,
  ...containerProps
}: FallbackComponentProps) => (
  <FullScreenFlex {...containerProps}>
    {debug ? (
      <Flex as="details" flexDirection="column" title="DebugErrorMessage">
        <Text tag="summary" css={styles.clickable}>
          Click to expand for error details
        </Text>
        <Text tag="h1" css={styles.marginTop}>
          This error was located at: {componentStack}
        </Text>
        <Flex flexDirection="column">
          <Text css={styles.instruction}>Check the console for the complete formatted log ...</Text>
          <Text css={styles.error}>
            Error Name:{` `}
            <Text tag="span" css={styles.errorDetail}>
              {error.name}
            </Text>
          </Text>
          <Text css={styles.errorWithMargin}>
            Error Message:{` `}
            <Text tag="span" css={styles.errorDetail}>
              {error.message}
            </Text>
          </Text>
          <Text css={styles.error}>
            Stringified Error:{` `}
            <Text tag="span" css={styles.errorDetail}>
              {error.toString()}
            </Text>
          </Text>
        </Flex>
        <Text css={styles.errorStack}>Error Stack:</Text>
        <Text css={styles.errorStackDetail}>{error.stack}</Text>
      </Flex>
    ) : (
      <Flex flexDirection="column" alignItems="center" justifyContent="center" css={styles.userComponentWrap}>
        <Text css={styles.text}>
          An unexpected error occurred.
          <br />
          If this problem persists, contact the team on
          <br />
          <Link href="mailto:support@flockcover.com">support@flockcover.com</Link>
          &nbsp;and we&apos;ll help you get up and running.
        </Text>
        <Button onClick={refreshPage} css={styles.marginTop}>
          Refresh page
        </Button>
      </Flex>
    )}
  </FullScreenFlex>
)
